import * as React from 'react';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';

export default function FloatingAddButton(props) {
  return (
    <Box disabled={props.disabled} onClick={()=>{props?.onClick();}} style={{position: 'fixed', right: 14, bottom: 24, zIndex: 999}} sx={{ '& > :not(style)': { m: 1 } }}>
      <Fab size="medium" color={"success"} aria-label="save">
        <AddIcon />
      </Fab>
    </Box>
  );
}